import type { SVGProps } from "react";
// generated from Forms.svg — do not edit manually
// prettier-ignore
export default function Forms(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 4 V 10 H 21 V 4 H 3 Z" stroke="currentColor" strokeWidth="1.5"/><path d="M 3 14 V 20 H 21 V 14 H 3 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
